(() => {
  // Prevent double-initialization
  if (window.__mifVideoAutoplayInit) return;
  window.__mifVideoAutoplayInit = true;

  const SELECTOR_GALLERY = 'media-gallery';
  const SELECTOR_SLIDE = 'slideshow-slide';
  const SELECTOR_DEFERRED = 'deferred-media';
  const SELECTOR_POSTER_BTN = '.deferred-media__poster-button';

  function isElementMostlyInView(el, ratio = 0.35) {
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const vw = window.innerWidth || document.documentElement.clientWidth;
    if (r.width <= 0 || r.height <= 0) return false;
    const visibleX = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
    const visibleY = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    const visibleArea = visibleX * visibleY;
    const totalArea = r.width * r.height;
    return totalArea > 0 && (visibleArea / totalArea) >= ratio;
  }

  function loadDeferredMedia(deferredEl) {
    if (!deferredEl) return false;

    // Some Shopify deferred-media elements expose a method (Dawn-style)
    if (typeof deferredEl.loadContent === 'function') {
      deferredEl.loadContent();
      return true;
    }

    // Fallback: "click" the poster button
    const btn = deferredEl.querySelector(SELECTOR_POSTER_BTN);
    if (btn) {
      btn.click();
      return true;
    }

    return false;
  }

  function playVideoIn(container) {
    const video = container?.querySelector?.('video');
    if (!video) return;

    // Autoplay rules: must be muted for most browsers.
    // In-app browsers (Messenger, Instagram) have stricter autoplay
    // policies — muted + playsInline + setAttribute are all required.
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.setAttribute('webkit-playsinline', '');

    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  }

  function pauseVideoIn(container) {
    const video = container?.querySelector?.('video');
    if (!video) return;
    video.pause();
  }

  function handleActiveSlide(gallery) {
    if (!gallery) return;
    if (!isElementMostlyInView(gallery, 0.25)) return;

    const activeSlide =
      gallery.querySelector(`${SELECTOR_SLIDE}[aria-hidden="false"]`) ||
      gallery.querySelector(`${SELECTOR_SLIDE}:not([aria-hidden="true"])`);

    if (!activeSlide) return;

    // Pause videos in non-active slides (prevents audio/CPU issues)
    gallery.querySelectorAll(SELECTOR_SLIDE).forEach((slide) => {
      if (slide !== activeSlide) pauseVideoIn(slide);
    });

    const deferred = activeSlide.querySelector(SELECTOR_DEFERRED);
    if (deferred) {
      loadDeferredMedia(deferred);

      // Give the browser a beat to swap template -> video, then try play
      requestAnimationFrame(() => {
        playVideoIn(activeSlide);
        setTimeout(() => playVideoIn(activeSlide), 150);
      });
    } else {
      // If the video is already present (not deferred), just play it
      playVideoIn(activeSlide);
    }
  }

  function initGallery(gallery) {
    // React to slide becoming active (aria-hidden flips)
    const mo = new MutationObserver(() => handleActiveSlide(gallery));
    mo.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });

    // Also react to scroll/resize (when the gallery comes into view)
    const onScroll = () => handleActiveSlide(gallery);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Initial attempt
    handleActiveSlide(gallery);
  }

  function boot() {
    document.querySelectorAll(SELECTOR_GALLERY).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
